export const CustomerStockValidation = (formData) => {
    const errors = {};

    if (!formData.vc_StockCode || !formData.vc_StockCode.trim()) {
        errors.vc_StockCode = 'This field is required';
    }
    if (!formData.mon_SalesPrice || !formData.mon_SalesPrice.trim()) {
        errors.mon_SalesPrice = 'This field is required';
    }
    if (!formData.SpecialPrice || !formData.SpecialPrice.trim()) {
        errors.SpecialPrice = 'This field is required';
    }
    return errors;
};
